export const UCHI_HOST_URL = (
  import.meta.env as ImportMetaEnv & { UCHI_HOST_URL: string }
).UCHI_HOST_URL;

export const UCHI_GRAPHQL_GATEWAY_URL = (
  import.meta.env as ImportMetaEnv & { UCHI_GRAPHQL_GATEWAY_URL: string }
).UCHI_GRAPHQL_GATEWAY_URL;
